import { formatMoney } from "../lib/site.js";

export default function RoiTable({ table }) {
  if (!table) return null;

  return (
    <section className="premium-card mt-10 overflow-hidden">
      <div className="border-b border-[var(--line)] bg-ivory p-5">
        <p className="text-sm font-black uppercase tracking-[0.18em] text-orange">ROI Plan</p>
        <h2 className="mt-1 text-2xl font-black text-royal">{table.title}</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-[760px] w-full border-collapse text-sm">
          <thead>
            <tr className="bg-royal text-white">
              <th className="border border-white/20 px-4 py-3 text-left">{table.amountLabel}</th>
              {table.columns.map((column) => (
                <th key={column.key} className="border border-white/20 px-4 py-3 text-left">
                  <span className="block font-black">{column.label}</span>
                  <span className="text-xs text-white/80">{column.rate.toFixed(2)}%</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row) => (
              <tr key={row.amount} className="odd:bg-white even:bg-[var(--surface-soft)]">
                <td className="border border-[var(--line)] px-4 py-3 font-black text-maroon">{formatMoney(row.amount)}</td>
                {table.columns.map((column) => (
                  <td key={column.key} className="border border-[var(--line)] px-4 py-3 font-bold text-ink">
                    {formatMoney(row[column.key])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
